import { Spin } from "antd";
import styled, { css } from "styled-components";

export const OptionSpin = styled(Spin)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
`;

export const MediaContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: 990px) {
    margin-top: 4rem;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      h1.title,
      h3.categoriesFoundText,
      .search-container input,
      .ant-select-selection-selected-value {
        color: #ffffff !important;
      }

      .ant-select {
        .ant-select-selector {
          background-color: #282828 !important;
          border-color: #282828 !important;
          color: #ffffff;
        }

        .ant-select-clear {
          background: transparent;
        }
      }
    `}

  h3.categoriesFoundText {
    margin-bottom: 30px;
    font-size: 21px;
  }

  h1.title {
    width: 100%;
    text-align: left;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .loading-point {
    width: 100%;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content-section-width-limiter {
    width: 100%;
    display: flex;
    max-width: 1920px;
    justify-content: center;

    .content-section {
      width: 100%;
      display: flex;
      padding: 2rem 0;
      align-items: center;
      flex-direction: column;
      overflow: hidden;

      .title,
      .inputs-section {
        padding-left: 4rem;
      }

      div.ant-spin {
        margin: 50px 0 20px 0;
      }

      .carousel-container {
        width: 100%;
        overflow-x: hidden;
        overflow-y: visible;
        padding-bottom: 200px;
        margin-bottom: -200px;
      }
    }
  }

  .inputs-section {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 50px;

    p {
      font-size: 18px;
      margin: 10px 0px;
    }

    .search-container {
      width: 100%;
      max-width: 500px;
      margin-right: 15px;

      .ant-input-search {
        margin: 0;
      }
    }

    .filters-container {
      display: flex;

      .categories-filter,
      .authors-filter {
        width: 200px;
        margin-right: 10px;
      }
    }

    .clear-button {
      cursor: pointer;
      color: ${({ theme }) => theme.colors.btnTextColor};
      background-color: ${({ theme }) => theme.colors.primary};
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #606060;
      border-radius: 8px;
      width: 42px;
      height: 44px;
      margin-left: 2px;
    }
  }

  .search-loading-container {
    width: 100%;
    display: flex;
    padding: 0 0 20px;
    align-items: center;
    justify-content: center;

    .ant-spin {
      margin-top: 15px;
    }
  }

  .empty-msg-container {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .secondary-slider {
    width: 100%;
    margin-bottom: 25px;

    h3 {
      margin-bottom: 15px;
    }
  }

  .categories-container {
    width: 100%;

    .secondary-slider {
      margin-bottom: 50px;

      h3 {
        margin-bottom: 0;
      }
    }
  }

  .secondary-slider:last-of-type {
    margin-bottom: 60px;
  }

  @media (max-width: 900px) {
    .content-section-width-limiter {
      padding: 0 30px;

      .content-section .title {
        padding-left: 7.5px;
      }
    }
  }

  @media screen and (max-width: 575px) {
    .inputs-section {
      flex-direction: column;

      .search-container {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }

    .filters-container,
    .categories-filter,
    .authors-filter {
      width: 100% !important;
    }

    .secondary-slider {
      margin-bottom: 40px;
    }
  }

  @media screen and (max-width: 450px) {
    && .filters-container {
      flex-direction: column;
      row-gap: 1rem;
    }
    .inputs-container {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      .search-container {
        width: 100%;
        margin-right: 0;
        margin-bottom: 15px;
      }

      .filters-container,
      .categories-filter,
      .authors-filter {
        flex: 1;
        width: 100%;
      }
    }
  }
`;
